import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { RequestFormBase } from '@bo-client/shared/base-components/request-form.base';
import { GridRegistrationModel } from '@bo-client/activation-management/grid-registration/model/grid-registration.model';
import { HttpHapService } from '@bo-client/core/http/http-hap.service';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import { LoadDataFormsGridRegistrationService } from '@bo-client/activation-management/shared/services/load-data-forms-grid-registration.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ErrorsFormsService } from '@bo-client/shared/form-errors/errors-forms.service';
import { CommissioningFormsErrorsService } from '@bo-client/activation-management/commissioning/forms/commissioning-forms-errors.service';
import { GridRegistrationRequestService } from '@bo-client/activation-management/grid-registration/grid-registration-request.service';
import { storageV2Process } from '@bo-client/activation-management/grid-registration/grid-registration-process.util';
import { CreateGridRegistrationFormsService } from '@bo-client/activation-management/grid-registration/create-grid-registration-forms.service';
import { DisplayAndSelectService } from '@bo-client/shared/components/display-and-selec-option/display-and-select.service';
import { uri } from '@bo-client/shared/constants/uri';
import { MeteringConceptModel } from '@bo-client/activation-management/shared/models/meteringConceptModel';
import { combineLatest, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { CompanyLocationDto } from '@bo-client/shared/models/companyLocations';
import {
  AnswerModalTypeEnum,
  DisplayAndSelectModel
} from '@bo-client/shared/components/display-and-selec-option/display-and-select.model';
import { DevelopmentAreaInfo } from '@bo-client/shared/models/developmentAreas';
import { MatStepper } from '@angular/material/stepper';
import {
  ErrorFormCommissioningEnum,
  ErrorStepsEnum
} from '@bo-client/activation-management/shared/forms/create-forms-errors-model';
import { AreaTypeEnum } from '@bo-client/activation-management/shared/models/commissioningModel';
import {
  GridRegistrationStatusEnum,
  GridRegistrationTypeConst,
  GridRegistrationTypeEnum,
  PowerGenerationSourceEnum
} from '@bo-client/activation-management/grid-registration/model/grid-registration.enum';
import { ShowErrorModel } from '@bo-client/shared/form-errors/errors-form-model';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { PVModuleModel } from '@bo-client/activation-management/grid-registration/model/pv-module.model';
import { ProducerModel } from '@bo-client/activation-management/grid-registration/model/producer.model';
import { ConsumerModel } from '@bo-client/activation-management/grid-registration/model/consumer.model';
import { CompareEnum, DocumentTagEnum } from '@bo-client/shared/constants/enums';
import { ActionWithMoreInfoModel } from '@bo-client/activation-management/shared/models/actionWithMoreInfo.model';
import { RequestApprovalDto } from '@bo-client/activation-management/grid-registration/model/RequestApprovalDto';
import {
  AnswerStateEnum,
  AnswerWithMoreInfoModel,
  NavigateToEnum
} from '@bo-client/activation-management/shared/models/AnswerWithMoreInfoModel';
import { path } from '@bo-client/shared/constants/path';
import { AuthorizationService } from '@bo-client/core/authorization/authorization.service';
import { ValidatorsService } from '@bo-client/shared/forms/validators.service';
import { UiAdaptionsModel } from '@bo-client/tenant-management/models/ui-adaptions.model';

@Component({
  selector: 'app-grid-registration-external-form',
  templateUrl: './grid-registration-external-form.component.html',
  styleUrls: ['./grid-registration-external-form.component.scss']
})
export class GridRegistrationExternalFormComponent
  extends RequestFormBase<GridRegistrationModel>
  implements OnInit, OnDestroy
{
  getAllValidationErrors(): ShowErrorModel[] {
    const errors = [...this.errorFormList];
    if (
      this.gridRegistrationType === this.gridRegistrationTypeEnum.PlugInProducer &&
      this.customConditionsCheckbox.invalid &&
      this.customConditionsCheckbox.touched
    ) {
      const errorMessage = new ShowErrorModel();
      errorMessage.displayName = 'Bedingungen';
      errorMessage.controlName = 'customConditionsCheckbox';
      errorMessage.errorMessage = 'Bitte akzeptieren Sie alle Bedingungen';
      errors.push(errorMessage);
    }
    return errors;
  }
  get eegCompensationContact() {
    return this.dataShareService.tenantConfig.gridRegistration.eegCompensationContact || '';
  }

  /**
   * Speicher des neuen Prozesses (v2)? Dann stellt `app-storage-v2-technical-summary` die
   * technischen Angaben dar, statt der auf PV und Ladeeinrichtung zugeschnittenen
   * Erzeuger-/Verbraucher-Zusammenfassungen.
   */
  get isStorageV2(): boolean {
    return storageV2Process(this.gridRegistration);
  }

  constructor(
    protected authorizationService: AuthorizationService,
    protected httpHapService: HttpHapService,
    public dataShareService: DataShareService,
    protected loadDataFormsGridRegistrationService: LoadDataFormsGridRegistrationService,
    protected route: ActivatedRoute,
    protected router: Router,
    protected toastService: ToastrService,
    protected errorsFormsService: ErrorsFormsService,
    protected commissioningFormsErrorsService: CommissioningFormsErrorsService,
    protected gridRegistrationService: GridRegistrationRequestService,
    protected createFormsGridRegistrationService: CreateGridRegistrationFormsService,
    protected displayAndSelectService: DisplayAndSelectService,
    private gridRegistrationRequestService: GridRegistrationRequestService,
    protected validatorsService: ValidatorsService
  ) {
    super(authorizationService, dataShareService);
  }

  @Output() onErrorsChanged = new EventEmitter<any>();
  public eventsToGis: Subject<string> = new Subject<string>();
  public gridRegistration: GridRegistrationModel = new GridRegistrationModel();
  public companyLocationsBytenant: CompanyLocationDto[];
  public listDevelopmentAreas: DevelopmentAreaInfo[];
  public storageConceptList: MeteringConceptModel[];
  public storageListToShow: DisplayAndSelectModel[];
  public selectedStorageConceptToShow: DisplayAndSelectModel;
  public meteringConceptList: MeteringConceptModel[];
  public meteringListToShow: DisplayAndSelectModel[];
  public selectedMeteringConceptToShow: DisplayAndSelectModel;
  public errorStepsEnum = ErrorStepsEnum;
  public areaTypePower = AreaTypeEnum.POWER;
  public gridRegistrationState = GridRegistrationStatusEnum;
  public gridRegistrationTypeEnum = GridRegistrationTypeEnum;
  public errorFormList: ShowErrorModel[] = [];
  public errorStepFormList: ShowErrorModel[] = [];
  public totalPowerProducers = 0;
  public totalPowerPVModules = 0;
  public hasPvModule = false;
  public documentRequired = false;
  public listInverterDevices: Array<ProducerModel> = [];
  public listProducers: Array<ProducerModel> = [];
  public listConsumers: Array<ConsumerModel> = [];
  public hasProducers = false;
  public gridRegistrationType: GridRegistrationTypeEnum;
  public gridRegistrationTypeText: string;
  public compareEnum = CompareEnum;
  public feederTypeEnum = PowerGenerationSourceEnum;
  public actions = this.gridRegistrationRequestService.actions;
  @ViewChild('stepper') private myStepper: MatStepper;
  private goToNextStept = false;
  private requestApprovalDto: RequestApprovalDto;
  public documentTagEnum = DocumentTagEnum;
  private compUnsubsSteps$ = new Subject<void>();
  public formGroup: FormGroup;
  customConditionsCheckbox = new FormControl(false);
  private uiAdaptions: UiAdaptionsModel[] = [];

  getFormGroup(): FormGroup<any> {
    return this.formGroup;
  }

  ngOnInit(): void {
    this.gridRegistrationType = GridRegistrationTypeEnum[this.route.snapshot.paramMap.get('gridType')];
    const idx = GridRegistrationTypeConst.findIndex(
      (ele) => ele.value.toLowerCase() == this.gridRegistrationType.toLowerCase()
    );
    this.gridRegistrationTypeText = GridRegistrationTypeConst[idx].displayName;

    this.dataShareService.uiAdaptions$.pipe(takeUntil(this.compUnsubs$)).subscribe((adaptions) => {
      this.uiAdaptions = adaptions;
      this.syncCustomConditionsCheckboxValidation();
    });
  }

  loadFormWithModel(result: GridRegistrationModel) {
    this.gridRegistration.id = result ? result.id : null;

    this.updateFormWithModel(result ? result : new GridRegistrationModel());
    const sources: any = {};
    sources.companyLocationByCurrentTenant = this.httpHapService.get(uri.companyLocationByCurrentTenant);
    sources.meteringConcept = this.dataShareService.meteringConcepts.meteringConcepts$;
    sources.storageConcept = this.dataShareService.meteringConcepts.storageConcepts$;
    sources.activeDevelopmentAreas = this.httpHapService.get(uri.getActiveDevelopmentAreas);
    combineLatest(sources)
      .pipe(takeUntil(this.compUnsubs$))
      .subscribe((answer: any) => {
        this.companyLocationsBytenant = answer.companyLocationByCurrentTenant;
        this.meteringConceptList = answer.meteringConcept;
        this.storageConceptList = answer.storageConcept;
        this.listDevelopmentAreas = answer.activeDevelopmentAreas;
        this.meteringConceptList = this.displayAndSelectService.sortMeteringConceptListBySortPosition(
          this.meteringConceptList
        );
        this.storageConceptList = this.displayAndSelectService.sortMeteringConceptListBySortPosition(
          this.storageConceptList
        );
        this.meteringListToShow = this.displayAndSelectService.meteringConceptToDisplayAndSelect(
          this.meteringConceptList
        );
        this.storageListToShow = this.displayAndSelectService.meteringConceptToDisplayAndSelect(
          this.storageConceptList
        );
        if (result) {
          if (result.meteringConcept) {
            this.selectedMeteringConceptToShow =
              this.displayAndSelectService.selectedMeteringConceptToDisplay(
                result.meteringConcept.id,
                this.meteringListToShow
              );
          }
          if (result.storageConcept) {
            this.selectedStorageConceptToShow = this.displayAndSelectService.selectedMeteringConceptToDisplay(
              result.storageConcept.id,
              this.storageListToShow
            );
          }
        }
      });
  }

  isValid() {
    if (!this.tryToSubmit) {
      this.detectFormChanges();
      this.tryToSubmit = true;
    }
    this.loadErrorsList();
    this.customConditionsCheckbox.markAllAsTouched();

    return this.errorFormList.length === 0 && this.customConditionsCheckbox.valid;
  }

  getModelFromForm(): GridRegistrationModel {
    this.gridRegistration = this.loadDataFormsGridRegistrationService.loadCommonData(
      this.gridRegistration,
      this.selectedGisData,
      this.formGroup
    );
    this.gridRegistration = this.loadDataFormsGridRegistrationService.loadGROtherInfoExternalUsers(
      this.gridRegistration,
      this.selectedCompanyLocation,
      this.formGroup
    );
    if (this.gridRegistration.id == null) {
      this.gridRegistration.tenant = {
        id: this.dataShareService.selectedTenant.id
      };
    }
    this.gridRegistration.gridRegistrationType = this.gridRegistrationType;

    return this.gridRegistration;
  }

  updateFormWithModel(result: GridRegistrationModel) {
    this.gridRegistration = result;

    this.selectedGisData = this.loadGisData(
      this.gridRegistration.connectionObject,
      this.gridRegistration.uniqueCoId
    );
    this.selectedCompanyLocation = this.gridRegistration.companyLocation;
    this.selectedCompanyLocationid = this.gridRegistration.companyLocation
      ? this.gridRegistration.companyLocation.id
      : null;
    this.formGroup = this.createFormsGridRegistrationService.createGridRegistrationForm(
      result ? result : new GridRegistrationModel(),
      this.gridRegistrationType
    );
    this.syncCustomConditionsCheckboxValidation();
  }

  loadErrorsList() {
    this.errorFormList = this.errorsFormsService.checkTwoLevelFormErrors(
      this.formGroup,
      ErrorFormCommissioningEnum,
      null
    );

    // Verfügbarkeitsprüfung Anschlussobjekt/Sparte (nur wenn availableAreas ermittelt)
    this.errorFormList = this.appendConnectionObjectAreaValidationErrors(this.errorFormList);

    console.log('emitting errors', this.errorFormList);
    this.onErrorsChanged.emit(this.errorFormList);
  }

  goForward(step: any) {
    if (step == this.errorStepsEnum.MoreInfo) {
      this.loadDataFromForm();
    }
    if (!this.goToNextStept) {
      this.detectFormChangesSteps();
      this.goToNextStept = true;
    }
    if (this.tryToSubmit) {
      this.loadErrorsList();
    }
    this.loadStepsErrorsList();
    if (step == this.errorStepsEnum.MoreInfo) {
      this.gridRegistration = this.loadDataFormsGridRegistrationService.resetConnectionObjectAdditionalInfo(
        this.gridRegistration,
        this.formGroup
      );
    }
    this.errorStepFormList = this.errorStepFormList.filter((ele) => ele.step == step);
    if (this.errorStepFormList.length == 0) {
      Object.keys(this.formGroup.controls).forEach((controlName) => {
        this.formGroup.controls[controlName].markAsUntouched();
      });
      this.myStepper.next();
    }
  }

  detectFormChangesSteps() {
    this.formGroup.valueChanges
      .pipe(takeUntil(this.compUnsubsSteps$), debounceTime(400), distinctUntilChanged())
      .subscribe(() => {
        this.loadStepsErrorsList();
      });
  }

  detectFormChangesForm() {
    this.formGroup.valueChanges
      .pipe(takeUntil(this.compUnsubs$), debounceTime(400), distinctUntilChanged())
      .subscribe(() => {
        this.loadStepsErrorsList();
      });
  }

  loadStepsErrorsList() {
    Object.keys(this.formGroup.controls).forEach((controlName) => {
      this.formGroup.controls[controlName].markAsTouched();
    });
    this.errorStepFormList = [];
    this.errorStepFormList = this.errorsFormsService.checkTwoLevelFormErrors(
      this.formGroup,
      ErrorFormCommissioningEnum,
      null
    );
    this.errorStepFormList = this.commissioningFormsErrorsService.updateErrorListAccordingCondition(
      this.selectedCompanyLocation == null,
      'companyLocation',
      this.errorFormList
    );
    if (this.gridRegistration.gridRegistrationType == this.gridRegistrationTypeEnum.Feeder) {
      if (this.gridRegistration.meteringConcept) {
        this.gridRegistration.meteringConcept =
          Object.keys(this.gridRegistration.meteringConcept).length === 0
            ? null
            : this.gridRegistration.meteringConcept;
      }
      this.errorStepFormList = this.commissioningFormsErrorsService.updateErrorListAccordingCondition(
        this.gridRegistration.meteringConcept == null,
        'meteringConcept',
        this.errorStepFormList
      );
    }
    if (this.formGroup.get('hasStorage').value) {
      this.errorStepFormList = this.commissioningFormsErrorsService.updateErrorListAccordingCondition(
        this.gridRegistration.storageConcept == null,
        'storageConcept',
        this.errorStepFormList
      );
    } else {
      this.errorStepFormList = this.commissioningFormsErrorsService.updateErrorListAccordingCondition(
        false,
        'storageConcept',
        this.errorStepFormList
      );
    }
    this.errorStepFormList = this.commissioningFormsErrorsService.updateErrorListAccordingCondition(
      this.totalPowerProducers >= this.dataShareService.tenantConfig.gridRegistration.vde4105UpperLimit &&
        !this.hasPvModule,
      'producers.exceedPower',
      this.errorStepFormList
    );
    this.errorStepFormList = this.commissioningFormsErrorsService.updateErrorListAccordingCondition(
      this.totalPowerPVModules >= this.dataShareService.tenantConfig.gridRegistration.vde4105UpperLimit &&
        this.hasPvModule,
      'pvModules.exceedPower',
      this.errorStepFormList
    );
  }

  selectedPVModule(event: any) {
    this.hasPvModule = event.isPv;
    const pvModulesArray = this.formGroup.get('pvModules') as FormArray;
    const producersArray = this.formGroup.get('producers') as FormArray;
    if (event.isPv) {
      pvModulesArray.push(this.createFormsGridRegistrationService.createPVModuleForm(new PVModuleModel()));
      if (event.hasProducer) {
        producersArray.push(this.createFormsGridRegistrationService.createProducerForm(new ProducerModel()));
      } else {
        producersArray.clear();
      }
    } else {
      producersArray.clear();
      producersArray.push(this.createFormsGridRegistrationService.createProducerForm(new ProducerModel()));
      pvModulesArray.clear();
    }
  }

  selectedGridRegistrationType($event) {
    switch ($event.action) {
      case AnswerModalTypeEnum.Selected:
        this.selectedMeteringConceptToShow = $event.selectedItem;
        const idx = this.meteringConceptList.findIndex((ele) => ele.id == $event.selectedItem.itemId);
        if (idx != -1) {
          this.gridRegistration.meteringConcept = this.meteringConceptList[idx];
        }
        break;
      case AnswerModalTypeEnum.Reset:
        this.selectedMeteringConceptToShow = null;
        this.gridRegistration.meteringConcept = null;
        break;
    }
    this.loadStepsErrorsList();
  }

  producerChangesDetection() {
    this.listProducers = (this.formGroup.get('producers') as FormArray).value;
    this.hasProducers = this.createFormsGridRegistrationService.checkIfHasProducers(this.listProducers);
    if (!this.hasProducers) {
      (this.formGroup.get('storages') as FormArray).clear();
    }
  }

  consumerChangesDetection() {
    this.listConsumers = (this.formGroup.get('producers') as FormArray).value;
  }

  totalPowerChanges($event) {
    if (!this.hasPvModule) {
      this.totalPowerProducers = $event.power;
      this.formGroup = this.loadDataFormsGridRegistrationService.setFeedInManagementInfoNotRequired(
        $event,
        this.formGroup
      );
    }
  }

  totalPowerPVModulesChanges($event) {
    this.hasPvModule = true;
    this.formGroup = this.loadDataFormsGridRegistrationService.setFeedInManagementInfoNotRequired(
      $event,
      this.formGroup
    );
  }

  isHasStorage($event) {
    this.gridRegistration.hasStorage = $event;
  }

  isSelectedStorageConcept($event) {
    switch ($event.action) {
      case AnswerModalTypeEnum.Selected: {
        this.selectedStorageConceptToShow = $event.selectedItem;
        const idx = this.storageConceptList.findIndex((ele) => ele.id == $event.selectedItem.itemId);
        if (idx != -1) {
          this.gridRegistration.storageConcept = this.storageConceptList[idx];
        }
        break;
      }
      case AnswerModalTypeEnum.Reset: {
        this.selectedStorageConceptToShow = null;
        this.gridRegistration.storageConcept = null;
        break;
      }
    }
  }

  hasInstalledDevices($event) {
    this.gridRegistration.hasInstalledDevices = $event;
  }

  registerDevice(action: ActionWithMoreInfoModel) {
    console.log('registering device, action: ', action);
    this.compUnsubsSteps$.next();
    this.detectFormChangesForm();
    this.loadErrorsList();
    this.loadStepsErrorsList();
    if (action.validateForm) {
      if (this.errorFormList.length > 0) {
        return;
      }
    }
    this.loadDataFromForm();
    this.requestApprovalDto = {
      id: this.gridRegistration.id ? this.gridRegistration.id : null,
      token: null,
      additionalData: this.gridRegistration
    };
    this[action.execute](action);
  }

  checkIfErrors(actionInfo: ActionWithMoreInfoModel) {
    return;
  }

  createExternalGridRegistration(action: ActionWithMoreInfoModel) {
    this.httpHapService
      .putOrPost(this.requestApprovalDto, action.actionUrl)
      .pipe(takeUntil(this.compUnsubs$))
      .subscribe(
        (answer: AnswerWithMoreInfoModel) => {
          this.getApiResponse(this.requestApprovalDto.id ? 'put' : 'post', answer, action);
        },
        (error) => {
          this.displayErrorMessage(error, action.failureMessage);
        }
      );
  }

  getApiResponse(apiMethod: string, answer: AnswerWithMoreInfoModel, actionInfo?: ActionWithMoreInfoModel) {
    switch (apiMethod) {
      case 'post':
      case 'put':
      case 'put': {
        this.showMessage(answer, actionInfo);
        this.navigateTo(answer);
        break;
      }
    }
  }

  displayErrorMessage(error: any, defaultMessage: string) {
    if (error.error.message) {
      this.toastService.error(error.error.message);
    } else {
      this.toastService.error(defaultMessage);
    }
  }

  showMessage(answer: AnswerWithMoreInfoModel, actionInfo?: ActionWithMoreInfoModel) {
    switch (answer.answerState) {
      case AnswerStateEnum.OK:
        if (answer.message) {
          this.toastService.success(answer.message);
          return;
        }
        if (actionInfo) {
          this.toastService.success(actionInfo.successMessage);
          return;
        }
        break;
      case AnswerStateEnum.ERROR:
        if (answer.message) {
          this.toastService.error(answer.message);
          return;
        }
        if (actionInfo) {
          this.toastService.error(actionInfo.failureMessage);
          return;
        }
        break;
    }
  }

  navigateTo(answer: AnswerWithMoreInfoModel) {
    if (answer.navigateTo != NavigateToEnum.none) {
      this.router.navigate([path.external + '/' + answer.navigateTo + '/' + answer.message], {
        replaceUrl: true
      });
    }
  }

  loadDataFromForm() {
    this.getModelFromForm();
  }

  private syncCustomConditionsCheckboxValidation(): void {
    if (this.gridRegistrationType !== this.gridRegistrationTypeEnum.PlugInProducer) {
      this.customConditionsCheckbox.clearValidators();
      this.customConditionsCheckbox.updateValueAndValidity();
      return;
    }
    const checkboxAdaption = this.uiAdaptions.find(
      (adaption) => adaption.anchor === 'gridRegistration.PlugInProducer.conditionsCheckbox'
    );
    this.updateCustomConditionsCheckboxValidation(checkboxAdaption);
  }

  private updateCustomConditionsCheckboxValidation(checkboxAdaption: UiAdaptionsModel | undefined): void {
    if (
      !this.customConditionsCheckbox.disabled &&
      checkboxAdaption &&
      (checkboxAdaption.visibility === 'show' || checkboxAdaption.visibility === 'true')
    ) {
      this.customConditionsCheckbox.setValidators(this.validatorsService.checkboxRequiredValidator());
    } else {
      this.customConditionsCheckbox.clearValidators();
    }
    if (
      this.gridRegistration?.state !== GridRegistrationStatusEnum.Incomplete &&
      this.gridRegistration?.state !== GridRegistrationStatusEnum.FeedbackNeeded
    ) {
      this.customConditionsCheckbox.clearValidators();
      this.customConditionsCheckbox.setValue(true);
    }
    this.customConditionsCheckbox.updateValueAndValidity();
  }

  ngOnDestroy() {
    this.compUnsubs$.next();
    this.compUnsubs$.complete();
  }
}
